import { render, staticRenderFns } from "./SchoolInformation.vue?vue&type=template&id=510ebe4d&scoped=true"
import script from "./SchoolInformation.vue?vue&type=script&lang=js"
export * from "./SchoolInformation.vue?vue&type=script&lang=js"
import style0 from "./SchoolInformation.vue?vue&type=style&index=0&id=510ebe4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ebe4d",
  null
  
)

export default component.exports